import api from './api'
import { HippaConsentData, HippaConsentResponse } from '@/types'

/**
 * Service for handling HIPAA consent operations
 */
export class ConsentService {
  /**
   * Submit HIPAA consent signature
   */
  static async submitHippaConsent(
    consentData: HippaConsentData
  ): Promise<HippaConsentResponse> {
    const response = await api.post<HippaConsentResponse>(
      '/agreements/signed/therapist',
      consentData
    )
    return response.data
  }

  /**
   * Get HIPAA consent status (optional, for checking status)
   */
  static async getHippaConsentStatus(): Promise<{ hasHippaSigned: boolean }> {
    const response = await api.get<{ hasHippaSigned: boolean }>(
      '/therapist/hippa-consent/status'
    )
    return response.data
  }
}
